import styled from 'styled-components'
import { LookButton, buttonLook } from 'components/Buttons/look'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const RatingContainer = styled.div`
  display: flex;
  position: absolute;
  top: -10px;
  right: -10px;
  height: 30px;
  padding: 0px 12px 0px 10px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 3px;
  border: 1px solid #EEEEEE;
  border-radius: 15px;
  background-color: #FFFFFF;
`

export const Image = styled.img`
  width: 100px;
  height: 100px;
  box-shadow: 0px 2px 10px -6px #252525;
  border-radius: 20px;
  margin-bottom: 15px;
`

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
`

export const Row = styled(Container)`
  width: 100%;
  padding: 0px;
  flex-direction: row;
  align-items: flex-start;
`

export const InfoText = styled.p`
  font-size: 14px;
  text-align: center;
  line-height: 20px;
  margin: 0px;
`

export const Title = styled(InfoText)`
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 20px;
`

export const SubTitle = styled(Title)`
  font-size: 14px;
  margin-bottom: 0px;
`

export const LinkText = styled.a`
  color: #35A7FF;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-decoration: none;

  &:hover {
    color: #2875E2;
  }
`

export const Button = styled(LookButton).attrs({ type: 'button' }).attrs(buttonLook({ variant: 'secondary' }))`
  width: 140px;
  align-self: center;
  margin: 10px 5px 0px;
`
